<template>
    <div>
      <reminder-report-list></reminder-report-list>
    </div>
  </template>
  
  <script>
  export default {
  }
  </script>
  